import React, { useEffect } from "react";
import { Timer } from "lucide-react";
import { useQzTrayConnection } from "../../../hooks/qztray/useQzTrayConnection";

/**
 * ⏱️ ConnectionUptimeBox
 *
 * Muestra el porcentaje de disponibilidad (uptime) del cliente QZ Tray.
 * Si no hay dato, se muestra un guion.
 */
const ConnectionUptimeBox: React.FC = () => {
  const { status, fetchStatus } = useQzTrayConnection();

  // 🚀 Obtener estado inicial
  useEffect(() => {
    fetchStatus();
  }, []);

  // 📊 Valor del uptime (si el backend lo envía)
  const uptime =
    typeof status?.uptime === "number"
      ? status.uptime
      : null;

  return (
    <div className="rounded-sm border border-stroke bg-white dark:border-strokedark dark:bg-boxdark shadow-md p-5 flex flex-col items-center justify-center transition-colors">
      {/* 🔹 Encabezado */}
      <div className="flex items-center gap-2 mb-2">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 dark:bg-primary/20">
          <Timer className="h-5 w-5 text-primary" />
        </div>
        <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300">
          Uptime
        </h4>
      </div>

      {/* 🔸 Valor principal */}
      <span className="text-2xl font-bold text-primary">
        {uptime !== null ? `${uptime.toFixed(2)}%` : "—"}
      </span>

      {/* 🔸 Descripción */}
      <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
        Tiempo activo del cliente
      </p>
    </div>
  );
};

export default ConnectionUptimeBox;
